// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Villa from './pages/Villa';
import ApartmentRooms from './pages/ApartmentRooms';
import ApartmentRoomsVilla from './pages/ApartmentRoomsVilla';
import AyurvedaSpa from './pages/AyurvedaSpa';
import AboutUs from './pages/AboutUs';
import Gallery from './pages/Gallery';
import ContactUs from './pages/ContactUs';

// Import the new booking-related components
import Search from './pages/Booking/Search';
import Booking from './pages/Booking/Booking';
import Checkout from './pages/Booking/Checkout';
import Confirmation from './pages/Booking/Confirmation';

function App() {
  return (
    <Router>
      <div>
        <Navbar />
        <div style={{ padding: "20px" }}>
          <Routes>
            {/* Existing routes */}
            <Route path="/" element={<Home />} />
            <Route path="/villa" element={<Villa />} />
            <Route path="/apartment-room" element={<ApartmentRooms />} />
            <Route path="/apartment-rooms-villa" element={<ApartmentRoomsVilla />} />
            <Route path="/ayurveda-spa" element={<AyurvedaSpa />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact-us" element={<ContactUs />} />

            {/* New booking-related routes */}
            <Route path="/booking" element={<Search />} />
            <Route path="/booking/booking" element={<Booking />} />
            <Route path="/booking/checkout" element={<Checkout />} />
            <Route path="/booking/confirmation" element={<Confirmation />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
